export default __webpack_public_path__ + "static/media/down.dcb8e3e1.svg";